import cx from "classnames";
import React, { memo, useContext } from "react";

import { Link } from "react-router-dom";

// Provider
import { AppContext } from "../../components/AppProvider";

// Utils
import { _O } from "../../modules/utils";

// Assets

// Env
import { prscUploadNew } from "./History";

// 전자처방전 Sub 메뉴
export const SUBS = [
  { url: "/eocs", code: "receipt", label: "약국접수" },
  { url: "/eocs/history/0", code: "history", label: "처방전기록" },
  // { url: "/eocs/regist/", code: "regist", label: "처방전 등록" }
  { url: "ep://paper/", code: "regist", label: "처방전 등록" },

  // { url: "/eocs/regist/test.jpg", code: "regist", label: "처방전 등록" }
];

// 전자처방전 약국접수(MY약국/주변약국/약국검색) 메뉴
export const TYPES_RECEIPT = [
  { url: "", code: "my", label: "MY 약국" },
  { url: "", code: "nearby", label: "주변약국" },
  { url: "", code: "search", label: "약국검색" },
];

// 전자처방전 처방전기록(접수중/접수완료) 메뉴
export const TYPES_HISTORY = [
  { url: "", code: "ing", label: "접수중 처방전" },
  { url: "", code: "end", label: "접수완료 처방전" },
];

export const TYPES_EXERCISE = [
  { url: "/sm/exercise/rcnt", code: "rcnt", label: "최근운동" },
  { url: "/sm/exercise/history/3/1/1", code: "history", label: "운동이력" },
];

/* Sub 메뉴 layout
    SUBS : Sub 메뉴 리스트
    code : 현재 선택된 메뉴 code
*/
export const SubMenu = memo(props => {
  const { SUBS, code, phoneOs } = props;
  const { phonecfg } = useContext(AppContext);

  return (
    <div className="top-roundtab-contain">
      <ul
        className={SUBS.length === 2 ? "w2" : SUBS.length === 3 ? "w3" : null}>
        {SUBS.map((m, i) =>
          i === 2 ? (
            // ? <li key={i}><a href={m.url} className={cx({ on: code === m.code })}>{m.label}</a></li>
            <li key={i}>
              <a
                href={void 0}
                className={cx({ on: code === m.code })}
                onClick={e => handlePaperEOCS(phoneOs)}>
                {m.label}
              </a>
            </li>
          ) : (
            <li key={i}>
              <Link to={m.url} className={cx({ on: code === m.code })}>
                {m.label}
              </Link>
            </li>
          )
        )}
      </ul>
    </div>
  );
});

const wsActive = () => {
  _O.OpenMenu("/eocs/history/1/1");
};

const handlePaperEOCS = phoneOS => {
  if (phoneOS === undefined) {
    console.log("phoneOS is undefined.");
    // alert("처방전 등록은 App에서만 가능합니다.");
    return;
  }

  try {
    // socketManager(SocketCommand.ADD_PAPER, wsActive);
    prscUploadNew("I", 0, "", "", "", "", []);
  } catch (err) {
    // alert("단말기에서 테스트 하세요.");
    // handleDialog("", "처방전 보기는 단말기에서만 동작됩니다.");
  }
};

/* Type 메뉴 layout
    TYPES : Type 메뉴 리스트
    code : 현재 선택된 메뉴 code
    setTypeIndex : 선택된 type 설정 callback function
*/
export const TypeMenu = memo(props => {
  const { TYPES, code, setTypeIndex, typeIndex } = props;

  return (
    <div className="pr-section">
      <div
        className={TYPES.length === 2 ? "round-blue-tab w2" : "round-blue-tab"}>
        {TYPES.map((m, i) => (
          <a
            key={i}
            className={cx({ on: code === m.code })}
            onClick={e => {
              if (setTypeIndex != null) setTypeIndex(i);
            }}>
            {m.label}
          </a>
        ))}
      </div>
    </div>
  );
});
